"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _categoryApi = require("@/api/categoryApi");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _permission = require("@/utils/permission");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default2 = exports.default = {
  name: 'Upload',
  props: {
    pictureType: {
      type: String,
      default: ''
    },
    isMore: {
      type: String,
      default: '1'
    },
    modelName: {
      type: String,
      default: ''
    },
    checkedMore: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxSizeKB: {
      type: Number,
      default: 0
    },
    maxSizeErrorMsg: {
      type: String,
      default: ''
    },
    acceptExts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    acceptErrorMsg: {
      type: String,
      default: ''
    },
    bothErrorMsg: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loadingPic: false,
      loading: false,
      modals: false,
      allTreeList: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      editPram: {
        pid: 1000,
        name: '',
        type: 2,
        sort: 1,
        status: 0,
        url: 'url',
        id: 0
      },
      visible: false,
      bizTitle: '',
      sleOptions: {
        attrId: '',
        pid: ''
      },
      list: [],
      grid: {
        xl: 7,
        lg: 7,
        md: 7,
        sm: 7,
        xs: 24
      },
      grid2: {
        xl: 17,
        lg: 17,
        md: 17,
        sm: 17,
        xs: 24
      },
      filterText: '',
      treeData: [],
      treeData2: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      tableData: {
        page: 1,
        limit: 20,
        pid: 0,
        attType: 'jpg,jpeg,gif,png,bmp,PNG,JPG'
      },
      classifyId: 0,
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      treeFrom: {
        status: -1,
        type: 2
      },
      pictrueList: {
        list: [],
        total: 0
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      listPram: {
        pid: 0,
        type: 2,
        status: 0,
        name: '',
        page: 1,
        limit: 9999
      },
      localImg: '',
      videoStatus: false,
      typeDate: 'pic',
      timer: null,
      uploadList: []
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    uploadAccept: function uploadAccept() {
      if (!this.acceptExts || !this.acceptExts.length) return '';
      return this.acceptExts.map(function (ext) {
        return ".".concat(String(ext).replace(/^\./, ''));
      }).join(',');
    },
    normalizedAcceptExts: function normalizedAcceptExts() {
      var aliases = {
        jpg: ['jpg', 'jpeg'],
        jpeg: ['jpg', 'jpeg']
      };
      var list = [];
      (this.acceptExts || []).forEach(function (ext) {
        var key = String(ext || '').replace(/^\./, '').toLowerCase();
        (aliases[key] || [key]).forEach(function (item) {
          if (item && !list.includes(item)) list.push(item);
        });
      });
      return list;
    }
  },
  mounted: function mounted() {
    this.pictureType ? this.tableData.limit = 30 : this.tableData.limit = 20;
    if (this.$route && this.$route.query.field === 'dialog') Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./internal.js'));
    });
    this.getList();
    this.getFileList();
    // this.handlerGetList()
  },
  methods: {
    checkPermi: _permission.checkPermi,
    pickFileExt: function pickFileExt(name, mime) {
      var src = String(name || '').toLowerCase().split('?')[0];
      if (src.includes('.')) return src.split('.').pop();
      var type = String(mime || '').toLowerCase();
      if (type.startsWith('image/')) return type.slice(6);
      return type;
    },
    isAcceptExt: function isAcceptExt(ext) {
      if (!this.normalizedAcceptExts.length) return true;
      return this.normalizedAcceptExts.includes(String(ext || '').toLowerCase());
    },
    isAcceptFile: function isAcceptFile(file) {
      if (!file || !this.normalizedAcceptExts.length) return true;
      var nameExt = this.pickFileExt(file.name);
      var mimeExt = this.pickFileExt('', file.type);
      var nameOk = !nameExt || this.isAcceptExt(nameExt);
      var mimeOk = !mimeExt || this.isAcceptExt(mimeExt);
      return nameOk && mimeOk;
    },
    isAcceptAttachment: function isAcceptAttachment(item) {
      if (!item) return false;
      var ext = this.pickFileExt(item.realName || item.name || item.sattDir || item.attDir || item.url, item.attType);
      return this.isAcceptExt(ext);
    },
    validateUploadFile: function validateUploadFile(file) {
      var typeFail = this.normalizedAcceptExts.length && !this.isAcceptFile(file);
      var sizeFail = this.maxSizeKB && file && file.size > this.maxSizeKB * 1024;
      if (typeFail && sizeFail) {
        this.$message.error(this.bothErrorMsg || this.acceptErrorMsg || this.maxSizeErrorMsg || '图片格式或大小不符合要求，请重新上传');
        return false;
      }
      if (typeFail) {
        this.$message.error(this.acceptErrorMsg || '图片格式不正确，请重新上传');
        return false;
      }
      if (sizeFail) {
        this.$message.error(this.maxSizeErrorMsg || "\u56FE\u7247\u5927\u5C0F\u9700\u5C0F\u4E8E\u7B49\u4E8E ".concat(this.maxSizeKB, "KB\uFF01"));
        return false;
      }
      return true;
    },
    mapUploadError: function mapUploadError(error) {
      var text = String(error && (error.message || error.msg) || '');
      if (this.acceptErrorMsg && /类型只能是|格式/.test(text)) return this.acceptErrorMsg;
      if (this.maxSizeErrorMsg && /大小|超过/.test(text)) return this.maxSizeErrorMsg;
      return text || '上传失败';
    },
    onBeforeUpload: function onBeforeUpload(file) {
      return this.validateUploadFile(file);
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var bMatch = str.match(/^([\d.]+)\s*B$/i);
      if (bMatch) return parseFloat(bMatch[1]);
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    isAttachmentOverMaxSize: function isAttachmentOverMaxSize(item) {
      if (!this.maxSizeKB || !item) return false;
      var sizeBytes = this.parseAttachmentSizeBytes(item);
      if (sizeBytes == null) return false;
      return sizeBytes > this.maxSizeKB * 1024;
    },
    getImageSizeBytes: function () {
      var _getImageSizeBytes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var parsed, url, cleanUrl, res, len, _res, blob, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              parsed = this.parseAttachmentSizeBytes(item);
              if (!(parsed != null)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, parsed);
            case 1:
              url = item && (item.sattDir || item.attDir || item.url) || '';
              cleanUrl = String(url).split('?')[0];
              if (cleanUrl) {
                _context.n = 2;
                break;
              }
              return _context.a(2, null);
            case 2:
              _context.p = 2;
              _context.n = 3;
              return fetch(cleanUrl, {
                method: 'HEAD'
              });
            case 3:
              res = _context.v;
              len = res.headers.get('content-length');
              if (!len) {
                _context.n = 4;
                break;
              }
              return _context.a(2, Number(len));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              _context.p = 6;
              _context.n = 7;
              return fetch(cleanUrl);
            case 7:
              _res = _context.v;
              _context.n = 8;
              return _res.blob();
            case 8:
              blob = _context.v;
              return _context.a(2, blob.size);
            case 9:
              _context.p = 9;
              _t2 = _context.v;
              return _context.a(2, null);
          }
        }, _callee, this, [[6, 9], [2, 5]]);
      }));
      function getImageSizeBytes(_x) {
        return _getImageSizeBytes.apply(this, arguments);
      }
      return getImageSizeBytes;
    }(),
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl: function imgSaveToUrl(event) {
      // 也可以用file
      this.localFile = event.raw; // 或者 this.localFile=file.raw

      // 转换操作可以不放到这个函数里面，
      // 因为这个函数会被多次触发，上传时触发，上传成功也触发
      var reader = new FileReader();
      reader.readAsDataURL(this.localFile); // 这里也可以直接写参数event.raw

      // 转换成功后的操作，reader.result即为转换后的DataURL ，
      // 它不需要自己定义，你可以console.integralLog(reader.result)看一下
      reader.onload = function () {
        // console.integralLog(reader.result)
      };

      /* 另外一种本地预览方法 */
      var URL = window.URL || window.webkitURL;
      this.localImg = URL.createObjectURL(event.raw);
      // 转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
    },
    closeModel: function closeModel() {
      this.$refs['editPram'].resetFields();
    },
    handlerSubmit: function handlerSubmit(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.editPram.pid == 10000) _this.editPram.pid = 0;
          _this.bizTitle === '添加分类' ? (0, _categoryApi.addCategroy)(_this.editPram).then(function (data) {
            _this.$message.success('创建成功');
            _this.visible = false;
            _this.getList();
          }) : (0, _categoryApi.updateCategroy)(_this.editPram).then(function (data) {
            _this.$message.success('编辑成功');
            _this.visible = false;
            _this.getList();
          });
        } else {
          return false;
        }
      });
    },
    // 表单分类
    handlerGetList: function handlerGetList() {
      var _this2 = this;
      var datas = {
        name: '全部图片',
        id: ''
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (data) {
        _this2.allTreeList = data;
        _this2.allTreeLis.unshift(datas);
      });
    },
    // 搜索分类
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 所有分类
    getList: function getList() {
      var _this3 = this;
      var data = {
        name: '全部图片',
        id: 10000
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (res) {
        _this3.treeData = res;
        _this3.treeData.unshift(data);
        _this3.treeData2 = _toConsumableArray(_this3.treeData);
      });
    },
    // 添加分类
    onAdd: function onAdd(id) {
      this.tableData.pid = id;
      if (this.tableData.pid === 10000) this.tableData.pid = 0;
      this.bizTitle = '添加分类';
      this.visible = true;
      if (id) this.editPram = {
        pid: id,
        name: '',
        type: 2,
        sort: 1,
        status: 0,
        url: 'url',
        id: 0
      };
    },
    // 编辑
    onEdit: function onEdit(id) {
      var _this4 = this;
      if (id === 10000) id = 0;
      this.bizTitle = '编辑分类';
      this.loading = true;
      (0, _categoryApi.infoCategroy)({
        id: id
      }).then(function (res) {
        _this4.editPram = res;
        _this4.loading = false;
      });
      this.visible = true;
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this5 = this;
      if (id === 10000) id = 0;
      this.$modalSure('删除该分类吗?').then(function () {
        (0, _categoryApi.deleteCategroy)({
          id: id
        }).then(function () {
          _this5.$message.success('删除成功');
          _this5.getList();
        });
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      this.checkPicList = [];
      this.tableData.pid = data.id;
      this.getFileList();
    },
    uploadItem: function uploadItem(param) {
      var _this6 = this;
      var formData = new FormData();
      var data = {
        model: this.modelName ? this.modelName : this.$route ? this.$route.path.split('/')[1] : 'product',
        pid: this.tableData.pid
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return (0, _systemSetting.fileImageApi)(formData, data, {
        silent: true
      }).then(function (res) {
        loading.close();
        _this6.$message.success('上传成功');
        // 确保返回值有效，并且在上传完成后刷新文件列表
        if (res) {
          console.log('Upload successful, response:', res);
          // 强制刷新文件列表
          _this6.getFileList();
        }
        return res;
      }).catch(function (error) {
        console.error('Upload error:', error);
        loading.close();
        _this6.$message.error(_this6.mapUploadError(error));
        throw error;
      });
    },
    // 上传
    handleUploadForm: function handleUploadForm(file) {
      var _this7 = this;
      var rawFile = file && file.file;
      if (rawFile && !this.validateUploadFile(rawFile)) return;
      this.uploadList.push(file);
      if (this.timer) return;
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.timer = setTimeout(function () {
        loading.close();
        function uploadFiles() {
          return _uploadFiles.apply(this, arguments);
        }
        function _uploadFiles() {
          _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var _t3;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  if (!(this.uploadList.length > 0)) {
                    _context2.n = 5;
                    break;
                  }
                  _context2.p = 1;
                  _context2.n = 2;
                  return this.uploadItem.call(this, this.uploadList[0]);
                case 2:
                  _context2.n = 4;
                  break;
                case 3:
                  _context2.p = 3;
                  _t3 = _context2.v;
                case 4:
                  // 递归调用，处理下一个文件的上传
                  this.uploadList.shift();
                  uploadFiles.call(this);
                  _context2.n = 6;
                  break;
                case 5:
                  // 所有文件上传完成后的逻辑
                  clearTimeout(this.timer);
                  this.timer = null;
                  this.tableData.page = 1;
                  this.getFileList();
                case 6:
                  return _context2.a(2);
              }
            }, _callee2, this, [[1, 3]]);
          }));
          return _uploadFiles.apply(this, arguments);
        }
        uploadFiles.call(_this7);
      }, 500);
    },
    // 文件列表
    getFileList: function getFileList() {
      var _this8 = this;
      if (this.tableData.pid === 10000) this.tableData.pid = 0;
      this.loadingPic = true;
      (0, _systemSetting.fileListApi)(this.tableData).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (res && res.list) {
                  // 确保列表数据正确
                  _this8.pictrueList.list = res.list.map(function (item) {
                    // 确保图片URL正确，添加时间戳避免缓存问题
                    if (item.sattDir) {
                      var timestamp = new Date().getTime();
                      var separator = item.sattDir.includes('?') ? '&' : '?';
                      item.sattDir = "".concat(item.sattDir).concat(separator, "t=").concat(timestamp);
                    }
                    return item;
                  });

                  // 如果是第一页且有数据，处理本地图片
                  if (_this8.tableData.page === 1 && _this8.pictrueList.list.length > 0) {
                    _this8.pictrueList.list[0].localImg = _this8.localImg;
                  }

                  // 更新显示状态
                  _this8.isShowPic = _this8.pictrueList.list.length === 0;

                  // 更新总数
                  _this8.pictrueList.total = res.total || 0;
                  console.log('Loaded file list:', _this8.pictrueList.list);
                } else {
                  // 如果没有数据或数据错误，初始化为空数组
                  _this8.pictrueList.list = [];
                  _this8.isShowPic = true;
                  _this8.pictrueList.total = 0;
                  console.warn('No file list data returned from API');
                }
                _this8.loadingPic = false;
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.error('Error loading file list:', error);
        _this8.loadingPic = false;
        _this8.pictrueList.list = [];
        _this8.isShowPic = true;
        _this8.pictrueList.total = 0;
        _this8.$message.error('获取图片列表失败: ' + (error.message || '未知错误'));
      });
    },
    pageChange: function pageChange(page) {
      this.tableData.page = page;
      this.checkPicList = [];
      this.getFileList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableData.limit = val;
      this.getFileList();
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this9 = this;
      var activeIndex = -1;

      // 检查图片是否已经被选中
      if (!item.isSelect) {
        // 标记为已选中
        this.$set(item, 'isSelect', true);
        this.checkPicList.push(item);
        console.log('Selected image:', item);
      } else {
        // 取消选中
        this.$set(item, 'isSelect', false);

        // 查找并移除已选中的图片
        this.checkPicList = this.checkPicList.filter(function (el) {
          return el.attId !== item.attId;
        });
        console.log('Unselected image:', item);
      }

      // 更新ID列表
      this.ids = this.checkPicList.map(function (item) {
        return item.attId;
      });

      // 更新选中图片的序号
      this.pictrueList.list.forEach(function (el, i) {
        if (el.isSelect) {
          var selectedIndex = _this9.checkPicList.findIndex(function (selected) {
            return selected.attId === el.attId;
          });
          el.num = selectedIndex !== -1 ? selectedIndex + 1 : 0;
        } else {
          el.num = 0;
        }
      });

      // 强制更新视图
      this.$nextTick(function () {
        _this9.$forceUpdate();
      });
    },
    // 点击使用选中图片
    checkPics: function () {
      var _checkPics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this0 = this;
        var invalid, i, sizeBytes, str, _i, selectedImages;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (this.checkPicList.length) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, this.$message.warning('请先选择图片'));
            case 1:
              if (!this.normalizedAcceptExts.length) {
                _context4.n = 2;
                break;
              }
              invalid = this.checkPicList.find(function (item) {
                return !_this0.isAcceptAttachment(item);
              });
              if (!invalid) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, this.$message.error(this.acceptErrorMsg || '图片格式不正确，请重新上传'));
            case 2:
              if (!this.maxSizeKB) {
                _context4.n = 6;
                break;
              }
              i = 0;
            case 3:
              if (!(i < this.checkPicList.length)) {
                _context4.n = 6;
                break;
              }
              _context4.n = 4;
              return this.getImageSizeBytes(this.checkPicList[i]);
            case 4:
              sizeBytes = _context4.v;
              if (!(sizeBytes != null && sizeBytes > this.maxSizeKB * 1024)) {
                _context4.n = 5;
                break;
              }
              return _context4.a(2, this.$message.error(this.maxSizeErrorMsg || "\u56FE\u7247\u5927\u5C0F\u9700\u5C0F\u4E8E\u7B49\u4E8E ".concat(this.maxSizeKB, "KB\uFF01")));
            case 5:
              i++;
              _context4.n = 3;
              break;
            case 6:
              if (!(this.$route && this.$route.query.field === 'dialog')) {
                _context4.n = 7;
                break;
              }
              str = '';
              for (_i = 0; _i < this.checkPicList.length; _i++) {
                // 确保图片URL有效
                if (this.checkPicList[_i] && this.checkPicList[_i].sattDir) {
                  str += '<img src="' + this.checkPicList[_i].sattDir + '">';
                }
              }
              /* eslint-disable */
              nowEditor.dialog.close(true);
              nowEditor.editor.setContent(str, true);
              _context4.n = 9;
              break;
            case 7:
              if (!(this.isMore === '1' && this.checkPicList.length > 1)) {
                _context4.n = 8;
                break;
              }
              return _context4.a(2, this.$message.warning('最多只能选一张图片'));
            case 8:
              // 确保选中的图片数据完整
              selectedImages = [].concat(_toConsumableArray(this.checkedMore), _toConsumableArray(this.checkPicList)).map(function (item) {
                // 确保每个图片对象都有完整的数据
                return _objectSpread(_objectSpread({}, item), {}, {
                  sattDir: item.sattDir || '',
                  attId: item.attId || 0,
                  name: item.name || '图片'
                });
              });
              console.log('Emitting selected images:', selectedImages);
              this.$emit('getImage', selectedImages);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function checkPics() {
        return _checkPics.apply(this, arguments);
      }
      return checkPics;
    }(),
    // 删除图片
    editPicList: function editPicList(tit) {
      var _this1 = this;
      if (!this.checkPicList.length) return this.$message.warning('请先选择图片');
      this.$modalSure().then(function () {
        (0, _systemSetting.fileDeleteApi)(_this1.ids.join(',')).then(function () {
          _this1.$message.success('刪除成功');
          _this1.getFileList();
          _this1.checkPicList = [];
        });
      });
    },
    // 移动分类点击
    handleSelClick: function handleSelClick(node) {
      if (this.ids.length) {
        this.sleOptions = {
          attrId: this.ids.join(','),
          pid: node.id
        };
        this.getMove();
      } else {
        this.$message.warning('请先选择图片');
      }
    },
    getMove: function getMove() {
      var _this10 = this;
      (0, _systemSetting.attachmentMoveApi)(this.sleOptions).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _this10.$message.success('操作成功');
                _this10.clearBoth();
                _this10.getFileList();
              case 1:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this10.clearBoth();
      });
    },
    clearBoth: function clearBoth() {
      this.sleOptions = {
        attrId: '',
        pid: ''
      };
      this.checkPicList = [];
      this.ids = [];
    },
    videoChange: function videoChange(val) {
      if (val == false) {
        this.$set(this.tableData, 'attType', 'jpg,jpeg,gif,png,bmp,PNG,JPG');
        this.getFileList();
      } else {
        this.$set(this.tableData, 'attType', 'video/mp4');
        this.getFileList();
      }
    },
    radioChange: function radioChange(val) {
      if (val === 'video') {
        this.videoChange(true);
      } else {
        this.videoChange(false);
      }
    }
  }
};